import './dismiss';



// WEBPACK FOOTER //
// ./project/client/src/core/components/alerts/index.js